<div class="col-4" [ngClass]="layoutClass">
    <a (click)="navigate()">
        <div class="widget" [ngClass]="estilos">
            <div class="row">
                <div *ngIf="isOK()">
                    <div class="col-4" style="display: inline-block;">
                        <i class="fa fa-5x" [ngClass]="icon"></i>
                    </div>
                    <div class="col-8 pull-right">
                        <span> {{descriptionKey|translate}}</span>
                        <h2 class="font-bold">{{num}}</h2>
                    </div>
                </div>


                <waitLoading [maxView]="false"></waitLoading>

                <div *ngIf="isError()">
                    <!-- TODO: Comporbar que el servicio no devuelve datos y mostrar la información -->
                    <div class="alert alert-info m-b-xs text-ellipsis col-12">
                        <span> <i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"> {{ 'Widget.error' | translate }}</i>

                        </span>
                    </div>
                </div>

            </div>
        </div>
    </a>
</div>